const ThemeConfig = {
  token: {
    // Seed Token
    colorPrimary: "#CE202F",
  },
};

export default ThemeConfig;
